import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import QuizEditor from "./pages/QuizEditor";
import QuestionEditor from "./pages/QuestionEditor";
import CategoryEditor from "./pages/CategoryEditor";
import QuizDetails from "./pages/QuizDetails";
import Navbar from "./components/Navbar";
import CreateQuiz from "./pages/CreateQuiz";
import AddCategory from "./pages/AddCategory"; 
import Login from "./pages/Login"; 
import AddAdmin from "./pages/AddAdmin"; 
import AdminList from "./pages/AdminList"; 
import ProtectedRoute from "./components/ProtectedRoute"; 
import { AuthProvider } from "./context/AuthContext"; 
import UserList from "./pages/UserList";
import PrizeList from "./pages/PrizeList";

function Layout() {
  const location = useLocation();
  const hideNavbarRoutes = ["/login"]; // Define routes where Navbar should be hidden

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Protected routes */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/quizzes" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
        <Route path="/questions" element={<ProtectedRoute><QuestionEditor /></ProtectedRoute>} />
        <Route path="/categories" element={<ProtectedRoute><CategoryEditor /></ProtectedRoute>} />
        <Route path="/create-quiz" element={<ProtectedRoute><CreateQuiz /></ProtectedRoute>} />
        <Route path="/quizzes/:id" element={<ProtectedRoute><QuizDetails /></ProtectedRoute>} />
        <Route path="/add-category" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
        <Route path="/add-admin" element={<ProtectedRoute role={["super_admin", "admin"]}><AddAdmin /></ProtectedRoute>} />
         <Route path="/prize-list" element={<ProtectedRoute role={["super_admin"]}><PrizeList /></ProtectedRoute>} />
        <Route path="/add-user" element={<ProtectedRoute role={["admin"]}><AddAdmin /></ProtectedRoute>} />
        <Route path="/admin-list" element={<ProtectedRoute role={["super_admin", "admin"]}><AdminList /></ProtectedRoute>} />
        <Route path="/user-list" element={<ProtectedRoute role={["super_admin", "admin"]}><UserList /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout />
      </Router>
    </AuthProvider>
  );
}

export default App;
